import React from 'react';
import { Menu, Icon } from 'antd';
import { Link } from 'react-router-dom';

const { SubMenu } = Menu;

export default function TopMenu(props) {
    return (
        <Menu
            theme="light"
            mode="horizontal"
            className="layout-top-menu"
            selectedKeys={[`${props.selectedPage}`]}
        >
            <Menu.Item
                key={'menu-apps'}
                className="option-apps"
                onClick={props.onOpenApps}
            >
                <div className="layout-content-manu-apps">
                    <div className="sub-content">
                        <a>
                            <Icon type="appstore"/>
                        </a>
                    </div>
                </div>
            </Menu.Item>
            {
                props.modulos.map(modulo => (
                    <SubMenu
                        key={modulo.id}
                        title={
                            <span>
                                <Icon
                                    type={modulo.icono === null ? "plus-square" : modulo.icono}
                                    style={{ fontSize: '18px' }}
                                />
                                <span>{modulo.nombre}</span>
                            </span>
                        }
                    >
                        {
                            modulo.paginas.map(pagina => (
                                <Menu.Item
                                    key={pagina.id}
                                    onClick={() => {
                                        props.onChange(pagina.id);
                                        localStorage.setItem('selectedPage', pagina.id)
                                    }}
                                >
                                    <Link
                                        to={pagina.url}
                                        style={{ textDecoration: 'none' }}
                                    >
                                        <Icon type={pagina.icono} />{pagina.nombre}
                                    </Link>
                                </Menu.Item>
                            ))
                        }
                    </SubMenu>
                ))
            }
        </Menu>
    );
}